// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3jaq7","clinicsSelect":"TableHeading_clinicsSelect__3fBHJ"};